import { css } from 'lit';
export const styles = css`:host>div{display:flex;gap:var(--der-ui-spacing-XS);flex-wrap:wrap;justify-content:center}`;
